import { render, staticRenderFns } from "./ThemeColors.vue?vue&type=template&id=9a7f6a70&scoped=true&"
import script from "./ThemeColors.vue?vue&type=script&lang=js&"
export * from "./ThemeColors.vue?vue&type=script&lang=js&"
import style0 from "./ThemeColors.vue?vue&type=style&index=0&id=9a7f6a70&prod&lang=scss&"
import style1 from "./ThemeColors.vue?vue&type=style&index=1&id=9a7f6a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7f6a70",
  null
  
)

export default component.exports